module.exports = __webpack_public_path__ + "static/media/image2.ca2596cc.jpg";